export default {
  container: {
    float: 'left'
  }
};
